import AdminLayout from './admin-layout';

export default function AdminLayoutPage() {
  return <AdminLayout />;
}
